<template>
  <div :class="containerClasses">
    <div v-if="fluid" :class="$style['inner-wrapper']">
      <slot />
    </div>
    <slot v-else />
  </div>
</template>

<script>
export default {
  name: 'ContainerElement',
  props: {
    fluid: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    containerClasses() {
      return this.fluid ? this.$style['container--fluid'] : `container ${this.$style.container}`
    },
  },
}
</script>

<style lang="scss" module>
// .container {
//   padding: 0;
// }

:global(.v-main > .v-main__wrap .container).container:first-of-type {
  padding-bottom: 0 !important;
}

.container--fluid {
  @media screen and (min-width: map-get($grid-breakpoints, 'md')) {
    padding: 0 0.5rem;
  }
  position: relative;
  right: 50%;
  left: 50%;

  width: 100vw;
  margin-right: -50vw;
  margin-left: -50vw;
  padding: 0;
}

.inner-wrapper {
  @media print {
    max-width: 100vw;
  }
  // max-width: 112.5rem;
  margin-right: auto;
  margin-left: auto;
}

:global(.content--launchportal) .inner-wrapper {
  max-width: none;
}
</style>
